export enum MandateDurationConfig {
  Limited,
  Unlimited
}
